import { Link } from 'react-router-dom';
import { cn } from '../lib/format';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-7', className)} aria-hidden>
      <rect width="32" height="32" rx="8" fill="#4F46E5" />
      <rect x="7" y="8" width="18" height="6" rx="2" fill="#fff" />
      <rect x="7" y="17" width="11" height="7" rx="2" fill="#A5B4FC" />
      <rect x="20" y="17" width="5" height="7" rx="2" fill="#FACC15" />
    </svg>
  );
}

export function Logo({
  to = '/',
  className,
  light,
  compact,
}: {
  to?: string;
  className?: string;
  light?: boolean;
  /** Only the mark on very narrow phones, so the header buttons fit. */
  compact?: boolean;
}) {
  return (
    <Link
      to={to}
      className={cn('flex shrink-0 items-center gap-2', className)}
      aria-label="Bannermatic"
    >
      <LogoMark />
      <span
        className={cn(
          'text-lg font-bold tracking-tight',
          light ? 'text-white' : 'text-zinc-900',
          compact && 'max-[419px]:hidden',
        )}
      >
        Bannermatic
      </span>
    </Link>
  );
}
